(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("EditPathExpiryModalCtrl", ["model", EditPathExpiryModalCtrl]);
    function EditPathExpiryModalCtrl(model) {
        var vm = this;
        vm.model = model;
    }
}());
